import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./StudentUsersUIHelpers";

const StudentUsersUIContext = createContext();

export function useStudentUsersUIContext() {
  return useContext(StudentUsersUIContext);
}

export const StudentUsersUIConsumer = StudentUsersUIContext.Consumer;

export function StudentUsersUIProvider({ children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);
  
  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams
  };

  return (
    <StudentUsersUIContext.Provider value={value}>
      {children}
    </StudentUsersUIContext.Provider>
  );
}